<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <PrintViewBar
          v-if="Invoice && currentBusiness"
          :showEmailBtn="showEmailBtn"
          :id="Invoice.id"
          type="invoice"
          :title="`Invoice # ${this.Invoice.localId}`"
          :postfix="`view?key=${currentBusiness.code}`"
          :name="currentBusiness.name"
          :email="printEmail"
          :obj="Invoice"
          :text="`${currentBusiness.name} Invoice click here to view`"
        />

        <v-container fluid>
          <v-card-text class="pb-0">
            <div v-if="!$vuetify.breakpoint.xsOnly">
              <img
                class="paidImg"
                v-if="Invoice.due === 0"
                width="300"
                src="../../../assets/paidStamp.png"
              />
              <img
                class="paidImg"
                v-if="Invoice.deletedAt"
                width="300"
                src="../../../assets/deletedStamp-removebg-preview.png"
              />
            </div>

            <v-layout row>
              <v-flex class="text-left text-capitalize">
                <div class="headline font-weight-bold">
                  {{ currentBusiness.name }}
                </div>
                <div class="font-weight-medium">
                  {{ currentBusiness.address }} {{ currentBusiness.city }},
                  <span class="text-uppercase"
                    >{{ currentBusiness.state }}
                  </span>
                  {{ currentBusiness.zip }}
                </div>
                <div class="font-weight-medium">
                  {{ currentBusiness.phoneNumber }}
                </div>
                <div class="font-weight-medium text-lowercase">
                  {{ currentBusiness.email }}
                </div>
                <div class="font-weight-medium text-lowercase">
                  {{ currentBusiness.website }}
                </div>

                <div
                  :class="{ 'display-3': !$vuetify.breakpoint.xsOnly }"
                  class="mt-5 text-h5 font-weight-black blue--text"
                >
                  INVOICE
                </div>
                <div class="font-weight-regular">
                  <div class="font-weight-medium">BILL TO</div>
                  <div class="font-weight-bold">
                    <span v-if="Invoice.Donor">{{ Invoice.Donor.name }}</span>
                    <span v-if="Invoice.Customer">{{
                      Invoice.Customer.name
                    }}</span>
                  </div>
                  <div>
                    <span v-if="Invoice.Donor">{{
                      Invoice.Donor.address
                    }}</span>
                    <span v-if="Invoice.Customer">{{
                      Invoice.Customer.address
                    }}</span>
                  </div>
                  <div v-if="Invoice.Donor && Invoice.Donor.city">
                    {{ Invoice.Donor.city }},<span class="text-uppercase"
                      >{{ Invoice.Donor.state }}
                    </span>
                    {{ Invoice.Donor.zip }}
                  </div>
                  <div v-if="Invoice.Customer && Invoice.Customer.city">
                    {{ Invoice.Customer.city }},<span class="text-uppercase"
                      >{{ Invoice.Customer.state }}
                    </span>
                    {{ Invoice.Customer.zip }}
                  </div>
                </div>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-right">
                <div v-if="!$vuetify.breakpoint.xsOnly">
                  <img
                    v-if="currentBusiness.imageUrl"
                    height="120"
                    class="logo mb-3"
                    :src="currentBusiness.imageUrl"
                    alt=""
                  />
                </div>
                <div v-if="!$vuetify.breakpoint.xsOnly" class="barcode mt-2">
                  *{{ Invoice.localId }}*
                </div>
                <div class="font-weight-regular">
                  <v-row>
                    <v-col class="pb-0">INVOICE #</v-col>
                    <v-col class="pb-0">{{ Invoice.localId }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col class="py-0">DATE: </v-col>
                    <v-col class="py-0">{{
                      Invoice.date | moment("MM/DD/YYYY")
                    }}</v-col>
                  </v-row>
                  <!-- <v-layout row>
                    <v-flex>
                      <div class="text-right">INVOICE #</div>
                      <div class="text-right">DATE:</div>
                      <div class="text-right">SALES REP:</div>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex shrink>
                      <div class="text-left">{{ Invoice.localId }}</div>
                      <div class="text-left">
                        {{ Invoice.date | moment("MM/DD/YYYY") }}
                      </div>
                      <div class="text-left" v-if="Invoice.SalesRep">
                        {{ Invoice.SalesRep.name }}
                      </div>
                      <div class="text-left" v-else>
                        {{ Invoice.User.name }}
                      </div>
                    </v-flex>
                  </v-layout> -->
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text
            class="pb-0"
            v-if="Invoice.Donor && Invoice.Donor.showBalance"
          >
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-flex shrink>
                <div class="headline font-weight-medium text-right blue--text">
                  BALANCE
                </div>
                <div class="display-2 font-weight-light text-right">
                  {{ Invoice.Donor.balance | currency }}
                </div>
                <br />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text
            class="pb-0"
            v-if="Invoice.Customer && Invoice.Customer.showBalance"
          >
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-flex shrink>
                <div class="headline font-weight-medium text-right blue--text">
                  BALANCE
                </div>
                <div class="display-2 font-weight-light text-right">
                  {{ Invoice.Customer.balance | currency }}
                </div>
                <br />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text class="pt-0 mt-5">
            <v-data-table
              :hide-default-header="$vuetify.breakpoint.smOnly"
              dense
              :headers="headers"
              sort-by="name"
              :itemsPerPage="Invoice.InvoiceDetails.length"
              hide-default-footer
              :items="Invoice.InvoiceDetails"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-left">
                    <div
                      :class="item.price < 0 ? 'font-weight-medium' : undefined"
                    >
                      {{ item.name }}
                      <span class="ml-1" v-if="item.price < 0">
                        <v-chip
                          v-if="item.refundTotal !== 0"
                          pill
                          small
                          color="blue-grey lighten-5"
                          text-color="blue-grey darken-4"
                        >
                          <v-icon left color="blue-grey darken-4" small>
                            mdi-cash-refund </v-icon
                          >Refund</v-chip
                        >
                      </span>
                    </div>
                    <div v-if="item.description" class="ml-5">
                      -{{ item.description }}
                    </div>
                  </td>
                  <!-- <td class="text-center">{{ item.qty }}</td> -->
                  <!-- <td class="text-right">
                    <span>{{ item.price | currency }}
                      <span v-if="showCost">/{{ item.cost | currency }}</span>
                    </span>
                  </td> -->
                  <td
                    :class="
                      item.price < 0 ? 'red--text text-right' : 'text-right'
                    "
                  >
                    {{ (item.price * item.qty) | currency }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-text class="pr-4">
            <v-divider></v-divider>
            <v-row>
              <!-- <v-col cols="3">
                <span v-if="showEmailBtn" @click="showCost = !showCost" class="pointer font-weight-medium">
                  {{ totalQty }} ITEM(S) SOLD
                </span>
                <span v-else @click="showCost = !showCost" class="font-weight-medium">
                  {{ totalQty }} ITEM(S) SOLD
                </span>

                <div class="signature">
                  <v-divider></v-divider>
                  <div>Signature</div>
                </div>
              </v-col> -->

              <!-- <v-spacer></v-spacer> -->
              <v-col sm="12" md="4" offset-md="8">
                <v-layout>
                  <v-flex>
                    <div class="font-weight-medium">SUBTOTAL:</div>
                  </v-flex>
                  <v-flex>
                    <div class="font-weight-medium text-right">
                      {{ Invoice.total | currency }}
                    </div>
                  </v-flex>
                </v-layout>
                <!-- <v-layout v-for="(payment, index) in Invoice.PaymentDetails" :key="index">
                  <v-flex>
                    <div class="text-right">
                      <span v-if="payment.donation" class="text-capitalize"> sponsor - </span>
                      <span v-if="payment.stripeChargeId" class="text-capitalize">{{ payment.stripeChargeId }} - </span>{{ payment.createdAt | moment("MM/DD/YYYY") }}
                    </div>
                  </v-flex>
                  <v-flex xs5>
                    <div class="red--text text-right">
                      {{ payment.amount | currency }}
                    </div>
                  </v-flex>
                </v-layout> -->
                <v-layout
                  v-for="(payment, index) in Invoice.PaymentDetails"
                  :key="index"
                  align-center
                >
                  <v-flex>
                    <div class="text-right">
                      <span v-if="payment.donation" class="text-capitalize">
                        sponsor -
                      </span>

                      <!-- Card payments -->
                      <span
                        v-if="payment.metadata && payment.metadata.card_type"
                      >
                        {{ payment.metadata.card_type }} ••••
                        {{ payment.metadata.last_4 }}
                      </span>

                      <!-- ACH payments -->
                      <span
                        v-else-if="
                          payment.metadata &&
                          payment.metadata.transaction &&
                          payment.metadata.transaction.check_details
                        "
                      >
                        ACH —
                        {{
                          payment.metadata.transaction.check_details
                            .account_type
                        }}
                        Account ••••{{
                          payment.metadata.transaction.check_details
                            .account_number_last4
                        }}
                        — Routing
                        {{
                          payment.metadata.transaction.check_details
                            .routing_number
                        }}
                      </span>

                      <!-- Stripe fallback -->
                      <span v-else-if="payment.stripeChargeId">
                        Txn {{ payment.stripeChargeId }}
                      </span>

                      <!-- Status -->
                      <span
                        v-if="payment.metadata && payment.metadata.status"
                        :class="{
                          'green--text': payment.metadata.status === 'Approved',
                          'red--text':
                            payment.metadata.status &&
                            payment.metadata.status !== 'Approved',
                        }"
                      >
                        — {{ payment.metadata.status }}
                      </span>

                      <!-- Authorization/Approval code -->
                      <span
                        v-if="payment.metadata && payment.metadata.auth_code"
                      >
                        — Auth: {{ payment.metadata.auth_code }}
                      </span>

                      <!-- Processor reference number -->
                      <span
                        v-if="
                          payment.metadata && payment.metadata.reference_number
                        "
                      >
                        — Ref: {{ payment.metadata.reference_number }}
                      </span>

                      <!-- Fallback to transaction id -->
                      <span
                        v-else-if="
                          payment.metadata &&
                          payment.metadata.transaction &&
                          payment.metadata.transaction.id
                        "
                      >
                        — Ref: {{ payment.metadata.transaction.id }}
                      </span>

                      <!-- Date -->
                      — {{ payment.createdAt | moment("MM/DD/YYYY") }}
                    </div>
                  </v-flex>

                  <v-flex xs5>
                    <div class="text-right font-weight-medium">
                      {{ payment.amount | currency }}
                    </div>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout>
                  <v-flex>
                    <div class="font-weight-medium">TOTAL PAID:</div>
                  </v-flex>
                  <v-flex>
                    <div class="font-weight-medium red--text text-right">
                      {{ Invoice.payment | currency }}
                    </div>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout>
                  <v-flex>
                    <div class="font-weight-medium">INVOICE DUE AMOUNT:</div>
                  </v-flex>
                  <v-flex>
                    <div class="font-weight-medium text-right">
                      {{ Invoice.due | currency }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-col>
            </v-row>
            <div v-if="currentBusiness.policy" class="font-weight-medium mt-3">
              POLICY
            </div>
            <v-divider></v-divider>
            <div style="line-height: 12px">
              <small>{{ currentBusiness.policy }}</small>
            </div>

            <v-divider class="my-4"></v-divider>

            <!-- Authorization Section -->
            <div class="font-weight-medium mt-3">PAYMENT AUTHORIZATION</div>
            <div style="line-height: 14px">
              <small>
                This payment was authorized by
                <span v-if="Invoice.Customer">{{ Invoice.Customer.name }}</span>
                <span v-else-if="Invoice.Donor">{{ Invoice.Donor.name }}</span>
                on {{ Invoice.date | moment("MM/DD/YYYY") }}. Amount:
                {{ Invoice.payment | currency }}.

                <span
                  v-if="
                    Invoice.PaymentDetails.length &&
                    Invoice.PaymentDetails[0].metadata
                  "
                >
                  Payment Method:
                  <span v-if="Invoice.PaymentDetails[0].metadata.card_type">
                    {{ Invoice.PaymentDetails[0].metadata.card_type }} ••••
                    {{ Invoice.PaymentDetails[0].metadata.last_4 }}
                  </span>
                  <span
                    v-else-if="Invoice.PaymentDetails[0].metadata.bank_account"
                  >
                    Account ending in
                    {{ Invoice.PaymentDetails[0].metadata.bank_account }}
                  </span>
                </span>

                <br /><br />
                <span
                  v-if="Invoice.Customer && Invoice.Customer.authorizationText"
                >
                  {{ Invoice.Customer.authorizationText }}
                </span>
                <span
                  v-else-if="Invoice.Donor && Invoice.Donor.authorizationText"
                >
                  {{ Invoice.Donor.authorizationText }}
                </span>
                <span v-else>
                  By providing my payment information and checking the
                  authorization box, I authorized Muhammadi Masjid to initiate
                  recurring debits from my account or card in the agreed amounts
                  and frequency. I understand that I may revoke this
                  authorization by written notice, and that I have recourse
                  rights if any debit does not comply with this agreement. For
                  more information, visit www.nacha.org.
                </span>
              </small>
            </div>

            <v-divider class="my-4"></v-divider>

            <v-col class="mt-4" align="right">
              Power By: <span>taleem.app</span>
              <!-- <img width="100" src="@/assets/images/poweredbylogo.png" /> -->
            </v-col>
          </v-card-text>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import PrintViewBar from "@/components/PrintViewBar";

import invoiceService from "../service";
import Hashids from "hashids";
import { mapGetters, mapActions } from "vuex";
const hashids = new Hashids();

export default {
  data() {
    return {
      showCost: false,
      showEmailBtn: true,
      isLoading: true,
      Invoice: {
        InvoiceDetails: [],
      },
      headers: [
        {
          text: "ITEM NAME",
          align: "left",
          value: "productDetail",
          sortable: false,
        },
        // {
        //   text: "QTY",
        //   align: "center",
        //   value: "qty",
        //   sortable: false,
        // },
        // {
        //   text: "RATE",
        //   align: "right",
        //   value: "rate",
        //   sortable: false,
        // },
        {
          text: "TOTAL",
          align: "right",
          value: "total",
          sortable: false,
        },
      ],
      totalQty: 0,
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    printEmail() {
      let email = null;
      if (this.Invoice.Donor && this.Invoice.Donor.email) {
        email = this.Invoice.Donor.email;
      }
      if (this.Invoice.Customer && this.Invoice.Customer.email) {
        email = this.Invoice.Customer.email;
      }

      return email;
    },
  },
  created() {
    if (this.$route.meta.public) {
      this.loadPublicData();
    } else {
      this.loadData();
      if (!this.currentBusiness) this.initUser();
    }
  },
  components: { PrintViewBar },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
    loadPublicData() {
      const id = hashids.decode(this.$route.params.id);
      const key = this.$route.query.key;
      return invoiceService
        .publicGetById(id, { invoice: true, key: key })
        .then((response) => {
          console.log("response invoice", response);
          this.initBusiness(response.business);
          this.$Progress.finish();
          this.Invoice = response.data;
          document.title = `${this.currentBusiness.name} - Invoice # ${this.Invoice.localId}`;
          if (this.Invoice.InvoiceDetails) {
            this.Invoice.InvoiceDetails.map((row) => {
              this.totalQty += Math.abs(parseInt(row.totalQty));
            });
          }
          this.isLoading = false;
        });
    },
    loadData() {
      const id = hashids.decode(this.$route.params.id);

      return invoiceService.getById(id, { invoice: true }).then((response) => {
        console.log("response not public", response);
        this.Invoice = response.data;
        if (this.Invoice.Donor && this.Invoice.Donor.email) {
          this.showEmailBtn = true;
        }
        if (this.Invoice.InvoiceDetails) {
          this.Invoice.InvoiceDetails.map((row) => {
            this.totalQty += Math.abs(parseInt(row.totalQty));
          });
        }
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .no-print {
    display: none;
  }

  .detailBox {
    overflow: visible;
    height: 100%;
  }

  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}

.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}

.center {
  background-color: white;
  margin: auto;
  width: 100%;
}

/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
